import { Directive, ElementRef } from '@angular/core';
import { ScrollControl } from '../../shared/stepper';
import { MatStepper } from '@angular/material/stepper';
import { scrollControl } from '../../shared/scroll';

@Directive({
  selector: '[appStepperScrollControl]'
})
export class StepperScrollControlDirective {

  constructor(private el: ElementRef, private host: MatStepper, private _scrollControl: ScrollControl) {
    this._scrollControl.getScrollControl().subscribe((res) => {
      const items = this.el.nativeElement.querySelectorAll('div[role="tabpanel"]');
      for (let i = 0; i < items.length; i++) {
        const firstControl = items[i].querySelector(res);
        if (firstControl) {
          this.host.selectedIndex = i;
          if (i === this.host.selectedIndex) {
            setTimeout(function () {
              scrollControl(firstControl);
            }, 0);
          }
          break;
        }
      }
    });
  }
}
